export enum SimulationStatus {
    PASSED = "passed",
    FAILED = "failed",
}
